import React, { useEffect } from "react";

import HomeHeader from "../components/home/HomeHeader/"; // Asta este un default import/export
import HomeServices from "../components/home/HomeServices/"; // Asta este un default import/export
import WhyChooseUs from "../components/home/WhyChooseUs/";
import FreeQuote from "../components/home/FreeQuote";
import FAQSection from "../components/home/FAQ";
import updateMetaTags from "../helpers/meta";
import { translateString } from "../helpers/translator";

const Home = ({ language = "en" }) => {
  useEffect(() => {
    updateMetaTags({
      title:
        language == "ro"
          ? "AzaSoftware - Servicii web, site-uri la comanda"
          : "Aza Software - Full Suite Software Services",
      description: translateString("HOME.META", language),
      keywords: translateString("HOME.KEYWORDS", language),
      image: "https://azasoftware.com/images/preview.jpg",
    });
  });
  return (
    <div className="page homepage">
      <HomeHeader language={language} />
      <HomeServices language={language} />
      <WhyChooseUs language={language} />
      <FreeQuote language={language} />
      <FAQSection language={language} />
    </div>
  );
};

export default Home;
